import { WprBaseGlobalScopeInfo } from '../wpr-framework/scope/WprBaseGlobalScopeInfo';
import { useLocation } from 'react-router-dom';

/**
 * グローバルスコープ情報
 */
export class GlobalScopeInfo extends WprBaseGlobalScopeInfo {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() { super('GlobalScopeInfo'); }
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 初期化通知
	 */
	public onInitialize(): void {
		// this.FW.setUrlParam('product', 'OTA');
		// this.FW.setUrlParam('agentcode', '20393');
		let productPrm: string = this.FW.getUrlParam('product');
		if (productPrm === null)
			productPrm = 'OTA';
		if (productPrm === 'DTA')
			productPrm = 'DTP';
		this.setGlobalScopeModel('product', productPrm);
		this.setGlobalScopeMode('product', productPrm);
		let agentPrm: string = this.FW.getUrlParam('agentcode');
		// (PayPayのみ)
		if (agentPrm === null) {
			let orderId: string = this.FW.getUrlParam('orderId');
			if (orderId != null) {
				let orderIds = orderId.split('_');
				agentPrm = orderIds[0];
			}
		}
		this.setGlobalScopeModel('agentcode', agentPrm);
		this.setGlobalScopeMode('agentcode', agentPrm);
		this.setGlobalScopeModel('location', location.pathname);
		// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル） START
		let inquiryNoPrm: string = this.FW.getUrlParam('inquiryNo');
		this.setGlobalScopeModel('inquiryNo', inquiryNoPrm);
		this.setGlobalScopeMode('inquiryNo', inquiryNoPrm);
		// WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル） END
	}
	// --------------------------------------------------------------------------

}
